module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search flex-all pl-3"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "write d-flex align-items-center justify-content-start"
  }, [_c('i', {
    staticClass: "ico-search larger pointer dark",
    on: {
      "click": _vm.searchTicket
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "query dark fs-small",
    attrs: {
      "type": "text",
      "placeholder": "Search ticket number"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchTicket.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-028be974"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Search.vue
// module id = 2051
// module chunks = 0